// removed by extract-text-webpack-plugin
module.exports = {"form":"DZhTPoDyShs7Vg3uTS-zA","buttons":"Uf8P7OlAk2Tm28tXEWXRp","transparentButton":"_3U8VOxoDydKhvgjTkO26cD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/components/MessageForm/MessageForm.scss
// module id = 1702
// module chunks = 0